import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { Icon } from '@components/icons';
import { useTranslation } from 'react-i18next';
import illustration from '@svg/illustrations/replace_successed.svg';

const ReplaceCardSuccessModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'replace_card_success'
    });
    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="" />
            <Typography className={styles.title} variant="h4">
                Success!
            </Typography>
            <Typography variant="body3" alignment="center" style={{ color: 'var(--neutral-40)' }}>
                Your card replacement request has been submitted successfully. You’ll receive your
                new card within 9 business days
            </Typography>
        </div>
    );
};

export default ReplaceCardSuccessModal;
